/**
 * Dark Mode - Night Eye — whole-page dark theming
 *
 * Declares two web-accessible-resource groups, both matched to every origin with no
 * `use_dynamic_url`. The first globs `css/*`, `_locales/*`, `js/browser-action/*` and
 * `html/browser-action/*`; the second exposes the single content script
 * `js/content/cssom.js`. All resolve from any page at a fixed URL.
 *
 * The content script is the cleanest signal — a vendor-named path served only when the
 * extension is installed, so fetching it is conclusive. The stylesheets corroborate.
 *
 * Manifest verified against version 6.1.0.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'alncdjedloppbablonallfbkeiknmkdi';

export const darkModeNightEye: ExtensionDefinition = {
  id: ID,
  name: 'Dark Mode - Night Eye',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 300_000,
  notes:
    'Two static WAR groups on every origin with no dynamic URL. Fetching the ' +
    'js/content/cssom.js content script is conclusive; the css/* files corroborate.',
  signals: [
    {
      id: 'war-content-cssom-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/content/cssom.js — the CSSOM content script, exposed to every origin ' +
        'at a fixed URL and served only when the extension is installed.',
      weight: 1,
      run: () => probeFetch(ID, 'js/content/cssom.js'),
    },
    {
      id: 'war-settings-css',
      kind: 'web-accessible-resource',
      description: 'Fetch css/settings.css — a bundled stylesheet, an independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/settings.css'),
    },
    {
      id: 'war-overview-css',
      kind: 'web-accessible-resource',
      description: 'Fetch css/overview.css — a third path, surviving either css file being renamed.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/overview.css'),
    },
  ],
};
